<template>
  <div>
    <data-table
      :headers="headers"
      :items="list"
      :loading="loading"
      :fetch="fetch"
      :search="query"
      :server-items-length="
        pagingMetadata.totalCount ? pagingMetadata.totalCount : Infinity
      "
      :reset-search="resetSearch"
      item-key="id"
      :options="options"
      :update-options="updateOptions"
    >
      <!-- ACTIVE field - HEADER -->
      <template v-slot:header.active="{ header }">
        {{ header.text }}
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              class="ml-5"
              text
              icon
              :color="active !== null ? 'primary' : ''"
            >
              <v-icon v-if="active !== null">mdi-filter-variant-remove</v-icon>
              <v-icon v-else>mdi-filter-variant</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              :class="active == null ? 'v-list-item--active' : ''"
              @click="updateActive()"
            >
              <v-list-item-title>{{ $t("Tous") }}</v-list-item-title>
            </v-list-item>
            <v-list-item
              :class="active === true ? 'v-list-item--active' : ''"
              @click="updateActive(true)"
            >
              <v-icon>mdi-account-check</v-icon>
              <v-list-item-title>{{ $t("Actif") }}</v-list-item-title>
            </v-list-item>
            <v-list-item
              :class="active === false ? 'v-list-item--active' : ''"
              @click="updateActive(false)"
            >
              <v-icon>mdi-account-outline</v-icon>
              <v-list-item-title>{{ $t("Inactif") }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <!-- LOCKED field - HEADER -->
      <template v-slot:header.locked="{ header }">
        {{ header.text }}
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              class="ml-5"
              text
              icon
              :color="locked !== null ? 'primary' : ''"
            >
              <v-icon v-if="locked !== null">mdi-filter-variant-remove</v-icon>
              <v-icon v-else>mdi-filter-variant</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              :class="locked == null ? 'v-list-item--active' : ''"
              @click="updateLocked()"
            >
              <v-list-item-title>{{ $t("Tous") }}</v-list-item-title>
            </v-list-item>
            <v-list-item
              :class="locked === true ? 'v-list-item--active' : ''"
              @click="updateLocked(true)"
            >
              <v-list-item-title>
                <v-icon>mdi-lock</v-icon>
                {{ $t("Bloqué") }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item
              :class="locked === false ? 'v-list-item--active' : ''"
              @click="updateLocked(false)"
            >
              <v-list-item-title>
                <v-icon>mdi-lock-open-outline</v-icon
                >{{ $t("Non Bloqué") }}</v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </template>

      <!-- ACTIVE field - ROW -->
      <template v-slot:item.active="{ item }">
        <!-- {{ item.active ? $t("Actif") : $t("Inactif") }} -->
        <v-icon v-if="item.active">mdi-account-check</v-icon>
        <v-icon v-else>mdi-account-outline</v-icon>
      </template>
      <!-- LOCKED field - ROW -->
      <template v-slot:item.locked="{ item }">
        <!-- {{ item.locked ? $t("x") : $t("-") }} -->
        <v-icon v-if="item.locked">mdi-lock</v-icon>
        <v-icon v-else>mdi-lock-open-outline</v-icon>
      </template>

      <template v-slot:item.actions="{ item }">
        <div class="d-flex justify-end">
          <create-button :entity="item">
            <template v-slot:default="{ on, loading }">
              <v-btn class="mr-5" text icon :loading="loading" @click="on">
                <v-icon>
                  mdi-pencil
                </v-icon>
              </v-btn>
            </template>
          </create-button>
          <delete-user-button :entities="[item]" />
        </div>
      </template>
      <!-- <template v-slot:bulkDeactivate="{ selectedEntities }">
        <deactivate-user-button :users="selectedEntities" v-slot="{ on }">
          <v-btn v-on="on" text color="primary">{{ $t("Désactiver") }}</v-btn>
        </deactivate-user-button>
      </template> -->
      <template v-slot:bulkDelete="{ selectedEntities, onSuccess }">
        <delete-user-button
          :entities="selectedEntities"
          v-slot="{ on, disabled }"
          @success="onSuccess"
        >
          <v-btn v-on="on" :disabled="disabled" text color="primary">{{
            $t("Supprimer")
          }}</v-btn>
        </delete-user-button>
      </template>
    </data-table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { FETCH, RESET_SEARCH } from "@/store/action-types";
import { mapUserSearchFormFields } from "@/store/modules/user";
import DataTable from "@/components/functional/DataTable";
import CreateButton from "@/components/users/CreateButton";
import DeleteUserButton from "@/components/users/DeleteUserButton";
// import DeactivateUserButton from "@/components/users/DeactivateUserButton";

const {
  mapActions: mapUserActions,
  mapState: mapUserState
} = createNamespacedHelpers(`user`);

const { mapActions: mapUserSearchFormActions } = createNamespacedHelpers(
  `user/searchForm`
);

export default {
  components: {
    DataTable,
    CreateButton,
    DeleteUserButton
    // DeactivateUserButton
  },
  data() {
    return {
      selected: [],
      headers: [
        { text: "Société", value: "agenceReference.nomComplet" },
        { text: "Prénom", value: "prenom" },
        { text: "Nom", value: "nom" },
        { text: "Email", value: "email" },
        { text: "Statut", value: "active", sortable: false },
        { text: "Bloqué", value: "locked", sortable: false },
        { text: "", value: "actions", sortable: false, align: "end" }
      ]
      // locked : null
    };
  },
  computed: {
    ...mapUserState(["list", "pagingMetadata"]),
    ...mapUserState({
      entityLoading: "loading"
    }),
    ...mapUserSearchFormFields(["query", "active", "locked", "options"]),
    ...mapUserSearchFormFields({
      entitySearchLoading: "loading"
    }),
    loading() {
      return this.entityLoading || this.entitySearchLoading;
    }
  },
  methods: {
    ...mapUserActions({
      fetch: FETCH
    }),
    ...mapUserSearchFormActions({
      resetSearch: RESET_SEARCH
    }),
    updateOptions(newOptions) {
      this.options = newOptions;
    },
    updateActive(isActive = null) {
      this.active = isActive;
      this.fetch({ reset: true });
    },
    updateLocked(isLocked = null) {
      this.locked = isLocked;
      this.fetch({ reset: true });
    }
  }
};
</script>

<style lang="scss" scoped>
.mdi-lock::before {
  content: "\F033E";
  color: red;
}
.mdi-account-outline::before {
  // content: "\F033E";
  color: #c0c0c0;
  opacity: 0.5;
}
</style>
